module.exports = __webpack_public_path__ + "static/media/Introducción_a_Kafka.41a948c5.png";